export default __webpack_public_path__ + "static/logo-218d1acc53ad3f3beb6295d274c5ab05.png";